import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { StageResponse } from "~types/stage.ts";

export const useGetSeasonStage = () => {
  const request = useApi();
  const { organizationId, sport, seasonId, stageCode } = useParams();

  return useQuery({
    queryKey: ["seasonStage", sport, organizationId, seasonId, stageCode],
    enabled: !!stageCode,
    queryFn: () =>
      request<StageResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/stages/${stageCode}`).then((response) => {
        const item = response?.data?.[0];
        if (!item) {
          throw new Error("Season stage not found");
        }

        return item;
      }),
  });
};
